function slug(value) {
  return String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function uniqueLargeSheetLayerSetId(name, existingIds = []) {
  const base = slug(name) || "nytt-oppsett";
  const existing = new Set(existingIds);
  if (!existing.has(base)) return base;
  let suffix = 2;
  while (existing.has(`${base}-${suffix}`)) suffix += 1;
  return `${base}-${suffix}`;
}

export function uniqueLargeSheetThemeValue(name, existingValues = []) {
  const base = slug(name) || "nytt-motiv";
  const existing = new Set(existingValues);
  if (!existing.has(base)) return base;
  let suffix = 2;
  while (existing.has(`${base}-${suffix}`)) suffix += 1;
  return `${base}-${suffix}`;
}

export function createLargeSheetTheme(template, input = {}) {
  const themeField = (template?.fields || []).find((field) => field.role === "labelTheme");
  if (!themeField) throw new Error("Designeren har ikke et motivfelt.");
  const label = String(input.label || "").trim();
  if (!label) throw new Error("Skriv inn et navn på motivet.");
  if (!input.previewImageUrl) throw new Error("Motivet mangler et forhåndsvisningsbilde.");
  if (!input.sheetImageUrl) throw new Error("Motivet mangler et produksjonsark.");
  if (!template.sheetTextLayers?.[input.sheetLayerSet]) throw new Error("Velg et gyldig designoppsett.");
  const value = uniqueLargeSheetThemeValue(label, (themeField.options || []).map((option) => option.value));
  const option = {
    value,
    label,
    category: String(input.category || "Andre").trim() || "Andre",
    imageUrl: input.previewImageUrl,
    thumbnailUrl: input.previewImageUrl,
    sheetImageUrl: input.sheetImageUrl,
    sheetLayerSet: input.sheetLayerSet,
    allowsBackgroundColor: input.allowsBackgroundColor === true,
    surfaceOpacity: 1,
    textInsetRatio: 0.18,
    priceDeltaNok: 0,
    uploaded: true,
    previewBlobName: input.previewBlobName || "",
    sheetBlobName: input.sheetBlobName || "",
    sheetWidth: Number(input.sheetWidth) || 0,
    sheetHeight: Number(input.sheetHeight) || 0,
  };
  themeField.options ||= [];
  themeField.options.push(option);
  return option;
}

export function duplicateLargeSheetLayerSet(template, sourceId, requestedName = "") {
  const layerSets = template?.sheetTextLayers || {};
  if (!Array.isArray(layerSets[sourceId])) throw new Error("Kildeoppsettet finnes ikke.");
  const id = uniqueLargeSheetLayerSetId(requestedName || `${sourceId}-kopi`, Object.keys(layerSets));
  template.sheetTextLayers[id] = structuredClone(layerSets[sourceId]);
  return id;
}

export function assignThemeToLargeSheetLayerSet(template, themeValue, layerSetId) {
  if (!template?.sheetTextLayers?.[layerSetId]) throw new Error("Designoppsettet finnes ikke.");
  const themeField = (template.fields || []).find((field) => field.role === "labelTheme");
  const option = (themeField?.options || []).find((item) => item.value === themeValue);
  if (!option) throw new Error("Motivet finnes ikke.");
  option.sheetLayerSet = layerSetId;
}

export function themesUsingLargeSheetLayerSet(template, layerSetId) {
  const themeField = (template?.fields || []).find((field) => field.role === "labelTheme");
  return (themeField?.options || []).filter((option) => option.sheetLayerSet === layerSetId);
}

export function removeLargeSheetLayerSet(template, layerSetId) {
  const layerSets = template?.sheetTextLayers || {};
  if (!layerSets[layerSetId]) throw new Error("Designoppsettet finnes ikke.");
  if (Object.keys(layerSets).length <= 1) throw new Error("Den siste designmalen kan ikke slettes.");
  const assignments = themesUsingLargeSheetLayerSet(template, layerSetId);
  if (assignments.length) throw new Error("Flytt motivene til et annet oppsett før du sletter.");
  delete layerSets[layerSetId];
}
